import { deserify, getMediaBasePath, IconWrapper, ImageWrapper, IStyles, pxToRem, pxTovW, ScoreProgressBar, theme } from '@geneo2-web/shared-ui'
import { Box, Divider, Typography, useMediaQuery } from '@mui/material'
import { BannerV2 } from '@protos/learning_management/lms.teacher.apis_pb';
import { useAppSelector } from 'apps/teacher/src/reduxStore/reduxHooks';
const styles: IStyles = {
  root: {
    width: { xs: pxToRem(270), md: pxTovW(530), lg: pxTovW(407) },
    display: 'flex',
    flex: '0 0 auto',
    boxShadow: `0px 0px ${pxToRem(8)} #00000029`,
    p: {
      xs: `${pxToRem(15)} ${pxToRem(13)} ${pxToRem(12)} ${pxToRem(18)}`,
      md: `${pxTovW(21)} ${pxTovW(19)} ${pxTovW(16)} ${pxTovW(25)}`
    },
    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
    background: '#FFFFFF',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(15) },
    margin: { xs: pxToRem(5), md: 0 },
    cursor: 'pointer'
  },
  iconImage: {
    width: { xs: pxToRem(25), md: pxTovW(39) },
    height: { xs: pxToRem(25), md: pxTovW(39) },
    borderRadius: '50%',
  },
  iconCard: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: { xs: pxToRem(10), md: pxTovW(10) }
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(2), md: pxTovW(3) },
    flexDirection: 'column',
    textAlign: 'center'
  },
  iconInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(3), md: pxTovW(5) },
  },
}
interface IProps {
  banner: BannerV2;
  key?: number;
  onClick?: () => void;
}
export const SnapShotBanner = (props: IProps) => {
  const { key, onClick, banner } = props;
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const fallbackIcon = user_info?.teachClassSubjects
    .find(
      (e: any) =>
        e.className === banner.class &&
        e.sectionId === banner.sectionId
    )
    ?.subjects.find(
      (sub: any) =>
        sub.subjectName === banner.subject
    )?.iconUrl;

  const isValidIcon = fallbackIcon && fallbackIcon !== 'false' && fallbackIcon !== 'null';
  const path = getMediaBasePath(
    banner.imageUrl !== 'string' ? banner.imageUrl : (isValidIcon ? fallbackIcon : undefined),
    'schoolnetStaticAssetBucket'
  );

  return (
    <Box sx={styles.root} onClick={onClick} key={key}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: pxToRem(6), md: pxTovW(8) }
      }}>
        <Box sx={{
          display: 'flex',
          gap: { xs: pxToRem(8), md: pxTovW(9) },
        }}>
          <ImageWrapper
            path={path}
            name={banner.subject.toLocaleLowerCase() || ''}
            type="png"
            parentFolder="icons"
            styles={styles.iconImage}
          />
          <Typography variant='h4' fontFamily={'poppins'} fontWeight={'bold'} color={'warning.main'} sx={{
            display: 'flex',
            marginY: 'auto'
          }}>{`${(banner.class)}${banner.section} ${(banner.subject)}`}</Typography>
        </Box>
        <Box sx={{
          width: '100%',
        }}>
          <ScoreProgressBar
            variant='lg'
            score={banner.progressPercent ? Math.round(banner.progressPercent) : 0}
          />
        </Box>
      </Box>
      <Typography variant='smallText' color='primary.main' marginLeft={'auto'}>View Detailed Analysis</Typography>
      <Divider />
      <Box sx={styles.iconCard}>
        <Box sx={styles.iconBox}>
          <Box sx={styles.iconInfo}>
            <IconWrapper
              name="clock"
              size='small'
              parentFolder="icons"
              type="png"
            />
            <Typography variant="smallText" fontWeight="bold">
              {banner.activeMinutes ? Math.round(
                Number(banner.activeMinutes)
              ) : 0}
            </Typography>
          </Box>
          <Typography
            variant="smallText"
            fontWeight="bold"
            sx={{ color: '#707070' }}
          >
            Active Minutes
          </Typography>
        </Box>
        <Box sx={styles.iconBox}>
          <Box sx={styles.iconInfo}>
            <IconWrapper
              name="questions"
              size='small'
              parentFolder="icons"
              type="png"
            />
            <Typography variant="smallText" fontWeight="bold">
              {banner.lessonsTaught ? banner.lessonsTaught : 0}
            </Typography>
          </Box>
          <Typography
            variant="smallText"
            fontWeight="bold"
            sx={{ color: '#707070' }}
          >
            Lessons Taught
          </Typography>
        </Box>

        <Box sx={styles.iconBox}>
          <Box sx={styles.iconInfo}>
            <IconWrapper
              name="reading"
              size='small'
              parentFolder="icons"
              type="png"
            />
            <Typography variant="smallText" fontWeight="bold">
              {banner.assessmentsAssigned ? banner.assessmentsAssigned : 0}
            </Typography>
          </Box>
          <Typography
            variant="smallText"
            fontWeight="bold"
            sx={{ color: '#707070' }}
          >
            Assessments Assigned
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
